import React from "react";
import CountUp from "react-countup";

const CounterCard = () => {
  return (
    <section className="section-wrap counter bg-dark" id="stats">
      <div className="container">
        <div className="row">
          <div className="col-sm-3 col-xs-6 mb-sm-40 animate">
            <div className="counter-item text-center">
              <CountUp start={0} end={6} delay={0} duration={6}>
                {({ countUpRef }) => (
                  <div>
                    <span className="counter-timer" ref={countUpRef} />
                  </div>
                )}
              </CountUp>
              <h5 className="counter-text">Estates</h5>
            </div>
          </div>

          <div className="col-sm-3 col-xs-6 mb-sm-40 animate">
            <div className="counter-item text-center">
              <CountUp start={0} end={5000} delay={0} duration={6}>
                {({ countUpRef }) => (
                  <div>
                    <span className="counter-timer" ref={countUpRef} />{" "}
                    <span
                      style={{
                        color: "#fff",
                        fontSize: " 50px",
                        fontFamily: "'Dosis', sans-serif",
                        letterSpacing: "0.1em",
                        position: "absolute",
                        top: "-15px",
                      }}
                    >
                      +
                    </span>
                  </div>
                )}
              </CountUp>
              <h5 className="counter-text">Homes</h5>
            </div>
          </div>

          <div className="col-sm-3 col-xs-6 mb-sm-40 animate">
            <div className="counter-item text-center">
              <CountUp start={0} end={8} delay={0} duration={6}>
                {({ countUpRef }) => (
                  <div>
                    <span className="counter-timer" ref={countUpRef} />
                  </div>
                )}
              </CountUp>
              <h5 className="counter-text">Countries</h5>
            </div>
          </div>

          <div className="col-sm-3 col-xs-6 animate">
            <div className="counter-item last text-center">
              <CountUp start={0} end={28} delay={0} duration={6}>
                {({ countUpRef }) => (
                  <div>
                    <span className="counter-timer" ref={countUpRef} />
                  </div>
                )}
              </CountUp>
              <h5 className="counter-text">Years In Business</h5>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CounterCard;
